export default __webpack_public_path__ + "images/PT.27b6cba.png";